<template>
  <layout-main-inner title="企业详情">
    <vendor-form :loading="loading"
      formStatus="detail"
      v-model="vendorInfo" />
    <template slot="footer">
      <back-button />
      <el-button type="primary"
        v-if="userPermission.OPERATE"
        @click="edit"
        :loading="loading">编辑</el-button>
    </template>
  </layout-main-inner>

</template>
<script>
import { guid } from '@/utils/index'
import VendorForm from './busi/vendor-form.vue'
import { mapState } from 'vuex'
export default {
  name: 'vender-detail',
  components: { VendorForm },
  data () {
    return {
      loading: false,
      vendorInfo: {
        menuNodes: []
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    edit (row) {
      this.$router.push(`/vendor-record-update?vendorId=${this.$route.query.vendorId}&type=partner`)
    },
    getapplyvendor () {
      this.loading = true
      this.$store.dispatch(`vendor/getvendor`, {
        payload: {
          vendorId: this.$route.query.vendorId
        },
        success: (res) => {
          this.loading = false
          res.data.businessLicenceFile = res.data.businessLicenceFile ? res.data.businessLicenceFile.split(',').map(item => ({
            url: item,
            name: item
          })) : []
          res.data.tagModels = res.data.tagModels ? res.data.tagModels.split(',') : []
          res.data.tagTypes = res.data.tagTypes ? res.data.tagTypes.split(',').map(item => +item) : []
          res.data.codingTypes = res.data.codingTypes ? res.data.codingTypes.split(',') : []
          res.data.tradeTypes = res.data.tradeTypes ? res.data.tradeTypes.split(',') : []
          res.data.categorys = res.data.categorys || []
          res.data.regulators = res.data.regulators || []
          res.data.functions = (res.data.functions || []).map(item => item.funcId)
          if (this.$route.query.type === 'partner') {
            res.data.menuNodes.forEach(item => {
              if (!item.funcId) {
                item.funcId = `custom-${guid()}`
              }
            })
          }
          this.vendorInfo = {
            ...this.vendorInfo,
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  mounted () {
    this.getapplyvendor()
  }
}
</script>
